const NewJobsIndex = () => import('./index.vue')

export default [
    {
        path: '/new/jobs',
        component: NewJobsIndex,
        name: 'NewJobsIndex'
    }
]